import { useRef } from 'react';

import useComponentDidMount from './useComponentDidMount';

/** Легаси-хук «componentWillMount»: синхронный вызов create при первом рендере. */
export default function useComponentWillMount(create: () => void) {
  const willMount = useRef(true);

  if (willMount.current) {
    create();
  }

  useComponentDidMount(() => {
    willMount.current = false;
  });
}
